import Vue from 'vue';
import VueRouter from 'vue-router';
import PokerPage from '../components/poker-page/PokerPage.vue';
import LoginPage from '../components/LoginPage.vue';
import ChatPage from '../components/chat/ChatPage.vue';
import store from '../plugins/store.js'
import QuestionsPage from "../components/QuestionsPage";
import PokerTablePage from "../components/poker-page/PokerTablePage";
import Notifications from "../components/chat/Notifications";
import AdminPage from "../components/AdminPage";
import ChatHistoryPage from "../components/ChatHistoryPage";
import MiningPage from "../components/MiningPage";
import ArchivePage from "../components/ArchivePage";
import ChatbotPage from "../components/ChatbotPage";

Vue.use(VueRouter)

const routes = [
  {
    path: '/poker',
    name: 'Poker',
    component: PokerPage,
    meta: {
      authenticated: true,
      simpleAllowed: true
    }
  },
  {
    path: '/',
    name: 'Chat',
    component: ChatPage,
    meta: {
      authenticated: true
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: LoginPage,
    meta: {
      authenticated: false
    }
  },
  {
    path: '/questions',
    name: 'Questions',
    component: QuestionsPage,
    meta: {
      authenticated: true
    }
  },
  {
    path: '/table',
    name: 'Table',
    component: PokerTablePage,
    meta: {
      authenticated: true
    }
  },
  {
    path: '/notifications',
    name: 'Notifications',
    component: Notifications,
    meta: {
      authenticated: true
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: AdminPage,
    meta: {
      authenticated: true,
      adminRequired: true
    }
  },
  {
    path: '/chat-history',
    name: 'ChatHistory',
    component: ChatHistoryPage,
    meta: {
      authenticated: true
    }
  },
  {
    path: '/mining',
    name: 'MiningPage',
    component: MiningPage,
    meta: {
      authenticated: true,
      minerRequired: true
    }
  },
  {
    path: '/archive',
    name: 'ArchivePage',
    component: ArchivePage,
    meta: {
      authenticated: true,
    }
  },
  {
    path: '/chatbot',
    name: 'ChatbotPage',
    component: ChatbotPage,
    meta: {
      authenticated: true,
      adminRequired: true
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes
});

router.beforeEach(async (to, from, next) => {
  if (!store.getters.isAuthenticated) {
    await store.dispatch('refresh');
  }
  // seems authenticated but has no user info, so refresh auth
  // if (!store.getters.isAuthenticated && store.getters.isLocalAuthenticated) {
  //   await store.dispatch('refresh');
  // }

  // check for simple role
  // redirect simple to Poker page if is not allowed
  if (to.matched.some(record => record.meta.simpleAllowed !== true)) {
    if (store.getters.isSimple && store.getters.isAuthenticated) {
      return next({ name: "Poker" })
    }
  }

  if (to.matched.some(record => record.meta.adminRequired === true)) {
    if(!store.getters.isAdmin){
      return next({ name: "Chat"})
    }
    return next();
  }
  if (to.matched.some(record => record.meta.minerRequired === true)) {
    if(!store.getters.isMiner){
      return next({ name: "Chat"})
    }
    return next();
  }
  if (to.matched.some(record => record.meta.authenticated === false)) {
    if(store.getters.isAuthenticated){
      return next({ name: "Chat"})
    }
    return next();
  }
  if (to.matched.some(record => record.meta.authenticated === true)) {
    if(!store.getters.isAuthenticated){
      return next({ name: "Login"})
    }
    return next();
  }

  return next();
})

export default router;
